/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ContentTypeEnum {
  PHOTO = "photo",
  VIDEO = "video",
}
